// Maximum file size for attachments: 35MB
export const MAX_ATTACHMENT_FILE_SIZE = 35 * 1024 * 1024;

export const FILE_MIME_TYPES = [
  'archive',
  'audio',
  'code-markup',
  'office-docs',
  'image',
  'video',
];

export interface FileUploadOptions {
  enabled: boolean;
  mandatory: boolean;
  categories: string[];
}

export const DEFAULT_FILE_UPLOAD_OPTIONS = {
  enabled: false,
  mandatory: true,
  categories: [],
};
